// extracted by mini-css-extract-plugin
module.exports = {"container":"activeInactiveToggleStyles_container__183kT","uirefresh":"activeInactiveToggleStyles_uirefresh__35rkU"};